export default {"src":"/_next/static/media/secure-coding-training.e547bb58.svg","height":465,"width":465,"blurWidth":0,"blurHeight":0};